export const getReservedQuantity = (order = {}) => {
  const reservedValue = order.reservedQty ?? 0;
  const normalizedReserved = Number(reservedValue);
  return Number.isFinite(normalizedReserved) ? normalizedReserved : 0;
};

export const getProductionQuantityForOrder = (order = {}) => {
  const productionValue = order.toProduceQty ?? 0;
  const normalizedProduction = Number(productionValue);
  return Number.isFinite(normalizedProduction) ? normalizedProduction : 0;
};

export const shouldDisplayOrder = (order = {}) => getProductionQuantityForOrder(order) > 0;
